import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { ThemeContext } from 'utils/theme';
import { sizes } from 'utils/detection';

import Wrapper from './styled/Wrapper';
import Img from './styled/Img';
import ImgWrapper from './styled/ImgWrapper';
import Paginator from './styled/Paginator';

export default class GallerySection extends PureComponent {
  static defaultProps = {
    showArrows: false,
    autoPlay: false,
    maxImages: 3,
    big: false,
  };

  static contextType = ThemeContext;

  state = {
    currentIndex: 0,
    numImagesToShow: 1,
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  refSlider = el => {
    this.slider = el;
  };

  afterIndexChange = index => {
    this.setState({ currentIndex: index });
    // if(appState.analytics)appState.analytics._trackEvent('GallerySection', 'change slide');
  };

  onPageSelect = index => {
    this.slider.slickGoTo(index);
    // if(appState.analytics)appState.analytics._trackEvent('GallerySection', 'click arrow');
  };

  onResize = () => {
    const { images, maxImages } = this.props;

    const isMedium = window.innerWidth >= sizes.medium;
    const numImagesToShow = isMedium ? Math.min(maxImages, images.length) : 1;
    this.setState({ numImagesToShow });
  };

  render() {
    const {
      autoPlay,
      maxImages,
      showArrows,
      images,
      orientation,
      big,
      videoHeight,
    } = this.props;
    const { currentIndex, numImagesToShow } = this.state;

    const sliderSettings = {
      arrows: false,
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: Math.min(maxImages, images.length),
      slidesToScroll: 1,
      initialSlide: 0,
      swipeToSlide: true,
      autoplay: autoPlay,
      responsive: [
        {
          breakpoint: sizes.medium,
          settings: {
            initialSlide: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };




    return (
      <Wrapper>
        <Slider
          {...sliderSettings}
          ref={this.refSlider}
          afterChange={this.afterIndexChange}
        >
          {images.map(({ id, url }) => (
            <ImgWrapper key={id}>
              <Img
                src={url}
                height={videoHeight}
                scaleMode="contain"
                orientation={orientation}
                big={big}
              />
            </ImgWrapper>
          ))}
        </Slider>
        {images.length > numImagesToShow && (
          <Paginator
            numPages={images.length}
            currentIndex={currentIndex}
            showArrows={showArrows}
            onPageSelect={this.onPageSelect}
          />
        )}
      </Wrapper>
    );
  }
}
